import { Component } from '@angular/core';
import { SpinnerService } from './features/services/spinner-service.service';
import { Subscription } from 'rxjs';
import {AuthService} from './core/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'PTCAdminDashboard';
  public spin : boolean = false;
  public spin1 : boolean = true;
  constructor(public spinnerService: SpinnerService, public authService: AuthService){
    this.spinnerService.getValue().subscribe((value)=>{
      this.spin = value;
    })

    this.authService.runInitialLoginSequence();
  }


}
